module.exports = __webpack_public_path__ + "_assets/img/nhri.40389d53.png";